<div #container id="container-generic">
  <div *ngIf="!isLoaded" no-bounce>
    <div class="general-container skl">
      <fun-spinner [color]="'medium'"></fun-spinner>
    </div>
  </div>

  <div *ngIf="isLoaded" id="container" [ngClass]="{ 'bg-detail-financing' : (project.status == 2 || project.status == 3 || project.status == 4 || project.status == 12 || project.status == 14 || project.status == 15) && !isFlexibleCompensation,
  'bg-mob-generic': !isFlexibleCompensation, 'bg-mob-ric': isFlexibleCompensation }"
    class="rnd border-eggplant-100/[0.2] min-h-screen pb-[78px] mb:pb-48">
    <div class="w-full pt-32 md:pr-[46px] md:pl-32 relative rnd-2"
      [ngClass]="{ 'bg-project-header' : project.status > 4 && project.status < 12 && project.status !== 14 && project.status !== 15 }">
      <div class="flex pl-12 md:pl-0">
        <div class="fixed right-12 md:right-[46px] hover:cursor-pointer z-50" (click)="closeModal()">
          <fun-icon [name]="'x-close'" [style]="'w-40 h-40 stroke-gray-40 stroke-2'"></fun-icon>
        </div>
      </div>
      <div *ngIf="isLoaded" class="w-full lg:max-w-[80%] xl:max-w-[60%] pt-[52px] mb-80 mx-auto">
        <h1 class="font-sansMedium text-center text-h600 md:text-h800 lg:text-h1000 px-16 md:px-0 text-eggplant-100">
          {{project.name}}</h1>
      </div>
      <div
        *ngIf="detailProject.show_priority_groups_timeline && (detailProject.status === 4 || detailProject.status === 3 || detailProject.status === 12)">
        <fun-overview-priority-group-timeline [detailProject]="detailProject"
          (bookInvestEvent)="controlAsideBtn('invest')"
          (addressChangedEvent)="initPage()"></fun-overview-priority-group-timeline>
      </div>
      <div *ngIf="project.status > 4 && project.status < 12"
        class="md:grid grid-cols-4 md:grid-cols-14 md:gap-x-32 lg:gap-x-32 place-content-center relative pt-32 md:pt-0 md:mb-32 pl-8 md:pl-0 scrollbar-none mob-none">
        <div class="md:col-span-12 md:col-start-3 relative mb-[-1px] max-w-[1125px]">
          <div *ngIf="detailProject.type === 1 && detailProject.id !== 38"
            class="cursor-pointer absolute left-[-34px] top-[14px]" (click)="prevSliderHeader()">
            <fun-icon [name]="'arrow-left'" [style]="'w-24 h-24 stroke-[4px] stroke-eggplant-100/[0.5]'"></fun-icon>
          </div>
          <ion-slides class="nav-slider" pager="false" [options]="navSlideOpts" id="headerSlider" #headerSlider>
            <ion-slide class="w-auto mr-8">
              <div (click)="viewNavclick('overview')" class="appear px-16 py-8 eyelash cursor-pointer"
                [ngClass]="{ 'selected' : currentPage === 'overview', 'noSelected' : currentPage !== 'overview' }">
                <div class="flex items-center gap-8">
                  <fun-icon *ngIf="currentPage === 'overview'" [name]="'briefcase'"
                    [style]="'stroke-[4px] stroke-[#FF7C92] hover:cursor-pointer w-24 h-24'"></fun-icon>
                  <fun-icon *ngIf="currentPage !== 'overview'" [name]="'briefcase'"
                    [style]="'stroke-[4px] stroke-eggplant-100/[0.5] hover:cursor-pointer w-24 h-24'"></fun-icon>
                  <p class="font-sans text-xl">{{ 'OVERVIEW.SUMMARY' | translate }}</p>
                </div>
              </div>
            </ion-slide>
            <ion-slide class="w-auto mr-8" *ngIf="headerInfo.hasUpdates">
              <div (click)="viewNavclick('news')" class="appear px-16 py-8 eyelash cursor-pointer"
                [ngClass]="{ 'selected' : currentPage === 'news', 'noSelected' : currentPage !== 'news' }">
                <div class="flex items-center gap-8">
                  <fun-icon *ngIf="currentPage === 'news'" [name]="'clock'"
                    [style]="'stroke-[4px] stroke-[#FF7C92] hover:cursor-pointer w-24 h-24'"></fun-icon>
                  <fun-icon *ngIf="currentPage !== 'news'" [name]="'clock'"
                    [style]="'stroke-[4px] stroke-eggplant-100/[0.5] hover:cursor-pointer w-24 h-24'"></fun-icon>
                  <p class="font-sans text-xl">{{ 'UPDATES.UPDATES' | translate }}</p>
                </div>
              </div>
            </ion-slide>
            <ion-slide
              *ngIf="detailProject.type === 1 && detailProject.id !== 38 && detailProject.status !== 9 && headerInfo.hasMonitoring"
              class="w-auto mr-8">
              <div (click)="viewNavclick('monitoring')" class="appear px-16 py-8 eyelash cursor-pointer "
                [ngClass]="{ 'selected' : currentPage === 'monitoring', 'noSelected' : currentPage !== 'monitoring' }">
                <div class="flex items-center gap-8">
                  <fun-icon *ngIf="currentPage === 'monitoring'" [name]="'bar-char-2'"
                    [style]="'stroke-[4px] stroke-[#FF7C92] hover:cursor-pointer w-24 h-24'"></fun-icon>
                  <fun-icon *ngIf="currentPage !== 'monitoring'" [name]="'bar-char-2'"
                    [style]="'stroke-[4px] stroke-eggplant-100/[0.5] hover:cursor-pointer w-24 h-24'"></fun-icon>
                  <p class="font-sans text-xl">{{ 'OVERVIEW.METRICS' | translate }}</p>
                </div>
              </div>
            </ion-slide>
            <ion-slide class="w-auto mr-8" *ngIf="headerInfo.hasDocumentation">
              <div (click)="viewNavclick('documentation')" class="appear px-16 py-8 eyelash cursor-pointer "
                [ngClass]="{ 'selected' : currentPage === 'documentation', 'noSelected' : currentPage !== 'documentation' }">
                <div class="flex items-center gap-8">
                  <fun-icon *ngIf="currentPage === 'documentation'" [name]="'paperclip'"
                    [style]="'stroke-[4px] stroke-[#FF7C92] hover:cursor-pointer w-24 h-24'"></fun-icon>
                  <fun-icon *ngIf="currentPage !== 'documentation'" [name]="'paperclip'"
                    [style]="'stroke-[4px] stroke-eggplant-100/[0.5] hover:cursor-pointer w-24 h-24'"></fun-icon>
                  <p class="font-sans text-xl">Docs</p>
                </div>
              </div>
            </ion-slide>
            <ion-slide class="w-auto mr-8" *ngIf="detailProject.id !== 38 && detailProject.status !== 9">
              <div (click)="viewNavclick('calendar')" *ngIf="headerInfo.hasCalendar"
                class="appear px-16 py-8 eyelash cursor-pointer "
                [ngClass]="{ 'selected' : currentPage === 'calendar', 'noSelected' : currentPage !== 'calendar' }">
                <div class="flex items-center gap-8">
                  <fun-icon *ngIf="currentPage === 'calendar'" [name]="'calendar'"
                    [style]="'stroke-[4px] stroke-[#FF7C92] hover:cursor-pointer w-24 h-24'"></fun-icon>
                  <fun-icon *ngIf="currentPage !== 'calendar'" [name]="'calendar'"
                    [style]="'stroke-[4px] stroke-eggplant-100/[0.5] hover:cursor-pointer w-24 h-24'"></fun-icon>
                  <p class="font-sans text-xl">{{ 'OVERVIEW.PAY' | translate }}</p>
                </div>
              </div>
            </ion-slide>
            <ion-slide class="w-auto mr-8" *ngIf="headerInfo.hasMarketplace && detailProject.status !== 9">
              <div (click)="viewNavclick('marketplace')" class="appear px-16 py-8 eyelash cursor-pointer "
                [ngClass]="{ 'selected' : currentPage === 'marketplace', 'noSelected' : currentPage !== 'marketplace' }">
                <div class="flex items-center gap-8">
                  <fun-icon *ngIf="currentPage === 'marketplace'" [name]="'file'"
                    [style]="'stroke-[4px] stroke-[#FF7C92] hover:cursor-pointer w-24 h-24'"></fun-icon>
                  <fun-icon *ngIf="currentPage !== 'marketplace'" [name]="'file'"
                    [style]="'stroke-[4px] stroke-eggplant-100/[0.5] hover:cursor-pointer w-24 h-24'"></fun-icon>
                  <p class="font-sans text-xl">{{ 'MOVEMENTS.NOTICEBOARD' | translate }}</p>
                </div>
              </div>
            </ion-slide>
            <ion-slide *ngIf="detailProject.type === 1" class="w-auto mr-8">
              <div (click)="viewNavclick('meeting')" *ngIf="headerInfo.hasMeetingList"
                class="appear px-16 py-8 eyelash cursor-pointer "
                [ngClass]="{ 'selected' : currentPage === 'meeting', 'noSelected' : currentPage !== 'meeting' }">
                <div class="flex items-center gap-8">
                  <fun-icon *ngIf="currentPage === 'meeting'" [name]="'coin-stack'"
                    [style]="'stroke-[4px] stroke-[#FF7C92] hover:cursor-pointer w-24 h-24'"></fun-icon>
                  <fun-icon *ngIf="currentPage !== 'meeting'" [name]="'coin-stack'"
                    [style]="'stroke-[4px] stroke-eggplant-100/[0.5] hover:cursor-pointer w-24 h-24'"></fun-icon>
                  <p class="font-sans text-xl">{{ 'MEETING.TITLE' | translate }}</p>
                </div>
              </div>
            </ion-slide>
          </ion-slides>
          <div *ngIf="detailProject.type === 1 && detailProject.id !== 38"
            class="cursor-pointer absolute right-[-24px] top-[14px]" (click)="nextSliderHeader()"><fun-icon
              [name]="'arrow-right'" [style]="'w-24 h-24 stroke-[4px] stroke-eggplant-100/[0.5]'"></fun-icon></div>
        </div>
      </div>
    </div>

    <div class="general-container generic">

      <div class="dsktp-none px-[18px] pb-32" *ngIf="project.status > 4 && project.status < 12">
        <fun-page-submenu #pageSubmenu [list]="pageList"
          (iconClickedEvent)="viewNavclick($event); scrollToContent();"></fun-page-submenu>
      </div>

      <div class="appear px-18 md:px-0 mb-32" *ngIf="currentPage === 'overview' &&
      ((!detailProject.user_can_invest_by_postal_code_now && detailProject.investment_by_postal_code_enabled
      && (detailProject.status === 4 || detailProject.status === 12 || detailProject.status === 3 || detailProject.status === 15))
      || (project.status === 14))">
        <fun-info [data]="infoData" (clickBtnEvent)="openInfoModal()"></fun-info>
      </div>
      <div *ngIf="project.id === 162"
        class="appear mb-32 flex flex-col md:flex-row justify-start gap-x-64 gap-y-20 my-20 px-20 py-28 md:py-12 rounded-xl shadow-xl linear-gradient-2">
        <p class="font-sans text-xl text-cream-100">El promotor de este proyecto,
          <a href="https://retreetheplanet.com/" target="_blank" rel="noopener noreferrer"
            className="text-white font-bold">Retree</a>, contribuye con una aportación de 93.000€.
        </p>
      </div>

      <div *ngIf="currentPage === 'overview'"
        class="flex flex-col-reverse justify-between gap-32 lg:flex-row appear px-24 lg:px-32">
        <div class="w-full lg:w-[58%] content appear">
          <div id="about">
            <div class="py-24"
              *ngIf="associatedProjectData && !associatedDataShowed && (detailProject.status === 4 || detailProject.status === 3 || detailProject.status === 12)">
              <div
                class="flex w-auto items-center cursor-pointer justify-between rounded-2xl bg-gray-10 md:pl-4 md:pr-8 md:py-4 p-12 bg-gray-10"
                (click)="changeDataToAssociatedProjectInfo()">
                <div class="flex justify-between flex-col md:flex-row txt-content">
                  <p class="font-sans text-s px-10 py-2 rounded-xl w-fit bg-eggplant-100 text-white">{{
                    associatedCompany }}</p>
                  <p class="font-sans text-s px-8 py-2 ext-eggplant-100">{{ 'OVERVIEW_PROJECT.VINCULATION' | translate
                    }}</p>
                </div>
                <div class="inline-block flex-end">
                  <fun-icon [name]="'arrow-right'" [style]="'w-24 h-24 stroke-[4px] stroke-[#29141F]'"></fun-icon>
                </div>
              </div>
            </div>
            <app-overview-aboutproject-section *ngIf="isLoaded && aboutSection"
              [aboutProjectInfo]="aboutProjectInfo"></app-overview-aboutproject-section>
            <div
              *ngIf="isLoaded && aboutSection && (detailProject.status === 3 || (detailProject.status === 4 && (!detailProject.user_can_invest_by_postal_code_now && detailProject.investment_by_postal_code_enabled)))"
              class="flex items-center justify-center pb-32">
              <fun-new-button [buttonType]="'colorFull'" [size]="'xl'"
                [title]="(detailProject.status === 3 ? 'OVERVIEW_PROJECT.ADVISE_ABOUT_NEWS' : 'OVERVIEW_PROJECT.ADVISE_WHEN_CAN_INVEST') | translate"
                (eventClick)="stayInformed()" [classExtra]="' w-auto mx-auto '"></fun-new-button>
            </div>

          </div>
          <div #teamB id="teamB">
            <app-overview-sections *ngIf="isLoaded && promoterSection && detailProject.status" [section]="'constructor'"
              [sectionInfo]="constructorInfo" (eventClickViewProject)="viewProjects($event)"></app-overview-sections>
          </div>
          <div class="my-32 relative w-full min-h-[265px] md:min-h-[420px] video-container"
            *ngIf="isLoaded && id && (id === 103 || id === 110 || id === 111 || id === 118 || detailProject.videoId)">
            <h2 class="font-sans text-h400 md:text-h600 text-eggplant-100/[0.25] pb-40">
              {{ 'OVERVIEW_PROJECT.ADDITIONAL_INFORMATION' | translate }}
            </h2>

            <!-- iOS: Botón para abrir en navegador -->
            <div *ngIf="isIOS"
              class="w-full min-h-[265px] md:min-h-[420px] flex items-center justify-center bg-eggplant-100/[0.55] rounded-lg cursor-pointer hover:opacity-90 transition-opacity"
              (click)="openYouTubeVideo()">
              <div class="text-center text-white flex flex-col gap-12 items-center justify-center">
                <!-- Icono de YouTube -->
                <fun-icon [name]="'play-circle'" [style]="'w-32 h-32 stroke-[4px] stroke-white'"></fun-icon>
                <p class="text-xl font-sans">Ver vídeo</p>
              </div>
            </div>

            <!-- Android y Web: iframe normal -->
            <iframe *ngIf="!isIOS && detailProject.youtubeUrl"
              class="w-full min-h-[265px] md:min-h-[420px] aspect-video rounded-lg" [src]="detailProject.youtubeUrl"
              title="Fundeen | Proyecto" frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowfullscreen playsinline webkit-playsinline>
            </iframe>
          </div>
          <div #investors id="investors">
            <app-overview-investors-section
              *ngIf="isLoaded && ( (investorsInfo.investorLevel.first + investorsInfo.investorLevel.fourth + investorsInfo.investorLevel.second + investorsInfo.investorLevel.third) > 0 )"
              [investorsInfo]="investorsInfo"></app-overview-investors-section>
          </div>
          <div *ngIf="hasContractSummary" class="appear">
            <app-overview-contract-summary [contractSummary]="project.locale"></app-overview-contract-summary>
          </div>
        </div>
        <div class="w-full lg:w-[34%] status">
          <div>
            <fun-overview-status-skeleton *ngIf="!isLoaded || !hasStatusaside"></fun-overview-status-skeleton>
            <app-overview-status-project (eventClickViewBTN)="controlAsideBtn($event)" (editInvestEvent)="editInvest()"
              (cancelReservationEvent)="cancelReservation($event)"
              (downloadAllDocumentsEvent)="downloadAllDocuments()"
              (calculateBeneffitsEvent)="scrollToCalculateBeneffits()" [info]="statusAside"
              [isFlexibleCompensation]="isFlexibleCompensation" [vinculatinUserList]="vinculatinUserList"
              [detailProject]="detailProject" *ngIf="isLoaded && hasStatusaside"></app-overview-status-project>
          </div>
        </div>
      </div>

      <div *ngIf="currentPage === 'news'" class="row appear px-18">
        <div class="col-2 col-md-12 navigation"></div>
        <div class="col-8 col-md-12 content-updates">

          <div class="pl-[18px] flex">
            <p class="font-sans text-l text-eggplant-100 pr-12">{{ 'PROJECT_LIST.ORDER_BY' | translate }}</p>
            <fun-filter-originator *ngIf="loadedUpdates" [defaultSelected]="defaultItemSelected" [items]="listOfFilter"
              (itemselectedEvent)="getFilter($event)"></fun-filter-originator>
          </div>
          <div *ngIf="!loadedUpdates">
            <fun-spinner></fun-spinner>
          </div>

          <app-update-list #update *ngIf="loadedUpdates" [updates]="realUpdates" [isInvestor]="isInvestor"
            [isDetail]="true" (eventEmitUuid)="downloadDoc($event)"></app-update-list>
        </div>
        <div class="col-2 col-md-12 status"></div>
      </div>
      <div class="row appear px-18" *ngIf="currentPage === 'marketplace' && activateMarketplace">
        <!-- <div *ngIf="loadingMkp">
          <fun-spinner></fun-spinner>
        </div> -->
        <div *ngIf="!hasMarketplace && !loadingMkp">
          <fun-overal-message text="{{ 'DASHBOARD.DETAIL_PROJECT.NO_MKP' | translate }}" [image]="2">
          </fun-overal-message>
        </div>
        <fun-project-detail #marketplaceRow *ngIf="hasMarketplace && !loadingMkp" [project]="projectMarketp"
          [hasWalletOk]="isWalletOk" (emitCreateBidToOffer)="createBid($event)" (eventCreateOffer)="createOffer()"
          [walletStatus]="walletStatus"></fun-project-detail>
        <fun-skeleton-list *ngIf="hasMarketplace && loadingMkp"></fun-skeleton-list>
      </div>
      <div class="row appear px-18 mb-48 md:mb-0" *ngIf="currentPage === 'documentation'">
        <div *ngIf="(!secondaryDocsLits || secondaryDocsLits.length === 0) && !investProjectDocuments">
          <fun-overal-message text="{{ 'DASHBOARD.DETAIL_PROJECT.NO_DOCUMENTATION' | translate }}" [image]="10">
          </fun-overal-message>
        </div>
        <app-documentation-list *ngIf="(secondaryDocsLits && secondaryDocsLits.length > 0) || investProjectDocuments"
          #documentation [investProjectDocuments]="investProjectDocuments"
          [secondaryDocsLits]="secondaryDocsLits"></app-documentation-list>
      </div>
      <div class="row appear payment_calendar_container px-18" *ngIf="currentPage === 'calendar'">
        <fun-calendar-pay-overview [calendarBenefits]="benefitsByMonth"
          [isInvestor]="isInvestor"></fun-calendar-pay-overview>
      </div>
      <!---->
      <div class="row appear px-18" *ngIf="currentPage === 'meeting'">
        <fun-overview-meeting [data]="meetingList" [project]="project"></fun-overview-meeting>
      </div>
      <!---->
      <div class="row appear px-18" *ngIf="currentPage === 'monitoring'">
        <fun-new-graphic *ngIf="lastUpdates && hasDailyProductionList && loadedDailyIncomeList"
          [data]="dailyProductionList" [dataIncomes]="dailyIncomeList" (clickYearPicker)="onClickYearPicker($event)"
          [lastUpdates]="lastUpdates" [listOfYears]="listOfYears" [date]="currentDate" [startDate]="startDate"
          [filter]="currentFilter" [productionEstimated]="productionEstimated" [productionToday]="productionToday"
          [moneyToday]="moneyToday" [moneyEstimated]="moneyEstimated" [productionHistoric]="productionHistoric"
          [moneyHistoric]="moneyHistoric"></fun-new-graphic>
        <!-- <fun-spinner *ngIf="!lastUpdates || !hasDailyProductionList || !loadedDailyIncomeList"></fun-spinner> -->
        <div *ngIf="!lastUpdates || !hasDailyProductionList || !loadedDailyIncomeList">
          <div class="py-32 w-full flex flex-col gap-32 items-center justify-center content-center appear">
            <!-- <fun-spinner></fun-spinner> -->
            <div class="pt-[32px]"><fun-icon [name]="'wifi'"
                [style]="'w-96 h-96 stroke-[2px] stroke-eggplant-70 animate-gradientX'"></fun-icon></div>
            <p class="text-center font-sans text-h400 md:text-h600 text-eggplant-70 animate-gradientX">{{
              'DETAIL_PROJECT.CONNECTING_PLANT_TITLE' | translate }}</p>
            <p class="text-center font-sans text-xl text-eggplant-70 animate-gradientX">{{
              'DETAIL_PROJECT.CONNECTING_PLANT_SUBTITLE' | translate }}</p>
          </div>
        </div>
      </div>
      <!---->
    </div>
  </div>
  <div
    *ngIf="currentPage === 'overview' && isLoaded && !refreshModalOpened &&
  (detailProject.status === 4 || detailProject.status === 12 || detailProject.status === 15 || detailProject.status === 14 || detailProject.status === 3)"
    id="calculator" #calculator>
    <fun-overvier-calculator [isFlexibleCompensation]="isFlexibleCompensation" [type]="detailProject.type"
      [status]="detailProject.status" [id]="detailProject.id" [profitability]="detailProject.profitability"
      [info]="statusAside" (openInvestEvent)="controlAsideBtn($event)"
      (calculateHubspotEvent)="changeHuspotStage('calculator', $event)"
      [investors]="(detailProject.inversors_profile.range_0.total + detailProject.inversors_profile.range_1.total + detailProject.inversors_profile.range_2.total + detailProject.inversors_profile.range_3.total)"></fun-overvier-calculator>
  </div>

</div>